import {
  Breadcrumbs,
  ClickAwayListener,
  Grow,
  IconButton,
  Link,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
  styled,
  Typography,
} from "@mui/material";

import RefreshButton from "../../../../../common/components/refresh_button";
import FormContainer from "../../../../../common/components/form_container";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { BackButton } from "../../../../../common/components/back_button";
import BottomBar from "../../../../../common/components/bottom_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { Controller } from "react-hook-form";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";
import { DropDownSubconta } from "../../../../../common/components/dropdown_subconta";
import { Link as LinkTo } from "react-router";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { useContasPagarCadastroViewModel } from "../../viewModels/contas_pagar_cadastro_view_model";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import DefaultInput from "../../../../../common/components/default_input";
import { DropDownFornecedor } from "../../../../../common/components/dropdown_fornecedor";
import { DropDownProdutoServico } from "../../../../../common/components/dropdown_produtoservico";
import { DropDownBanco } from "../../../../../common/components/dropdown_banco";
import { CopiaContasPagarModal } from "../ContasPagar_lista/components/copia_conta_pagar_modal";
import { DefaultFormMoneyInput } from "../../../../../common/components/default_form_money_input";
import { FormSwitchInput } from "../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { DefaultRadioGroupInput } from "../../../../../common/components/default_radio_group_input";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { DefaultCheckBox } from "../../../../../common/components/default_checkbox";
import { DefaultFormMultiAutocomplete } from "../../../../../common/components/default_form_multi_autocomplete";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export const ContasPagarCadastro = () => {
  const viewModel = useContasPagarCadastroViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row w-full justify-end gap-2">
              {viewModel.contaPagarSelectedId && (
                <div className="w-[100px] ">
                  <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => viewModel.handleGenerateReport()}
                  >
                    Relatório
                  </PrimaryButton>
                </div>
              )}
              <BackButton onClick={() => viewModel.handlePageBack()} />
              <div>
                <Stack direction="row" spacing={2}>
                  {viewModel.contaPagarSelectedId && (
                    <div className="w-[130px] ">
                      <PrimaryButton
                        buttonColor="yellow"
                        startIcon={
                          <DynamicIcon nameIcon="AddRounded" size={25} />
                        }
                        onClick={() => viewModel.handleNewRateioGeral()}
                      >
                        Rateio
                      </PrimaryButton>
                    </div>
                  )}

                  <div className="w-[12rem]">
                    <PrimaryButton
                      ref={viewModel.menuRef}
                      id="composition-button"
                      aria-controls={
                        viewModel.openMenu ? "composition-menu" : undefined
                      }
                      aria-expanded={viewModel.openMenu ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={viewModel.handleToggleMenu}
                      buttonColor="primary-green"
                    >
                      Opções
                    </PrimaryButton>
                    <Popper
                      style={{ zIndex: 10000 }}
                      open={viewModel.openMenu}
                      anchorEl={viewModel.menuRef.current}
                      placement="bottom-start"
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "bottom-start"
                                ? "left top"
                                : "left bottom",
                          }}
                        >
                          <Paper>
                            <ClickAwayListener
                              onClickAway={viewModel.handleCloseMenu}
                            >
                              <MenuList
                                autoFocusItem={viewModel.openMenu}
                                id="composition-menu"
                                aria-labelledby="composition-button"
                                onKeyDown={viewModel.handleListKeyDown}
                              >
                                <MenuItem
                                  onClick={() =>
                                    viewModel.handleNewContaPagar()
                                  }
                                >
                                  Nova conta a Pagar
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    viewModel.handleContaPagarCopiaOpenState(
                                      true,
                                    )
                                  }
                                >
                                  Copiar{" "}
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    viewModel.handleContaPagarDeleteOpenState(
                                      viewModel.contaPagarSelectedId ?? null,
                                      true,
                                    )
                                  }
                                >
                                  Excluir{" "}
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Stack>
              </div>
            </div>
          }
        />
      </PageTopBar>

      <form className="pb-8" onSubmit={viewModel.handleSalvarContaPagar}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Financeiro
            </Link>
            <Link underline="hover" color="inherit" component={"span"}>
              <LinkTo to="/ContasPagar_lista">Contas Pagar Lista</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro Contas Pagar
            </Typography>
          </Breadcrumbs>

          <div className="flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Contas Pagar
              </h1>
              <RefreshButton onClick={() => { }} />
            </div>
          </div>

          <div className="flex gap-2 items-center w-full">
            {viewModel.contaPagar && (
              <div className="w-full mt-3 text-black dark:text-white p-4 rounded-xl bg-gray-100 dark:bg-gray-800 shadow-sm">
                <div className="text-lg">
                  <span className="font-semibold mr-2">N° Conta a Pagar:</span>
                  <span className="font-bold">
                    {viewModel.contaPagar.nrContasPagar}
                  </span>
                </div>

                {/* <div className="text-lg ">
                                    <span className="font-semibold mr-2">Valor Mês:</span>
                                    <span className="font-bold">
                                        {viewModel.rateioGeralContaPagar.dataPagar
                                            ? new Date(viewModel.rateioGeralContaPagar.dataPagar).toLocaleDateString("pt-BR")
                                            : ""}
                                    </span>
                                </div> */}
              </div>
            )}
          </div>

          {/* STATUS */}
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
            <FormContainer
              title="Status da Conta"
              arrangement="fullRow"
              border={false}
            >
              <div className="flex flex-col items-center w-full gap-4">
                <div className="flex flex-col items-start w-full gap-4">
                  <FormRadioGroupInput
                    name="status"
                    label="Status"
                    readOnly={viewModel.statusBloqueio}
                    onValueChange={(e) => {
                      const valor = isNaN(Number(e)) ? e : Number(e);
                      viewModel.handleStatusChange(valor as number);
                    }}
                    options={[
                      { id: 0, label: "Em Aberto" },
                      { id: 1, label: "Pago" },
                      { id: 2, label: "Outros" },
                      { id: 3, label: "Atrasado" },
                    ]}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                {viewModel.contaPagar && viewModel.contaPagar.status === 2 && (
                  <div className="grid grid-cols-2 gap-4 w-full justify-between bg-red-100 dark:bg-red-500 p-8">
                    <DefaultFormInput
                      name="outros"
                      label="Motivo"
                      multiline={true}
                      rows={5}
                      maxRows={10}
                      required={false}
                      readOnly={false}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                )}

                {viewModel.contaPagar && viewModel.contaPagar.status === 1 && (
                  <div className="grid grid-cols-2 gap-4 w-full justify-between bg-green-100 dark:bg-green-800  p-8">
                    <div className="gap-4 w-full justify-between">
                      <div className="bg-white-100 pb-2">
                        <DropDownBanco
                          name="idBancoPagamento"
                          label="Banco"
                          required={false}
                          readOnly={viewModel.statusBloqueio}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="flex flex-row gap-3">
                        <FormDatePickerInput
                          name="dataPago"
                          required={true}
                          label="Data Pagamento"
                          readOnly={viewModel.statusBloqueio}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>
                    </div>
                    <div className="gap-3 w-full justify-between">
                      <div className="bg-white-100 pb-2">
                        <DefaultFormMoneyInput
                          name="valorPago"
                          label="Valor Pago"
                          required={true}
                          readOnly={viewModel.statusBloqueio}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="flex flex-row gap-3">
                        <DefaultFormMoneyInput
                          name="valorMulta"
                          label="Multa"
                          required={false}
                          readOnly={viewModel.statusBloqueio}
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormMoneyInput
                          name="valorJuros"
                          label="Juros"
                          required={false}
                          readOnly={viewModel.statusBloqueio}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </FormContainer>

            {/* FORM PRINCIPAL */}
            <FormContainer
              title="Informações"
              arrangement="fullRow"
              border={false}
            >
              <div className="flex flex-col items-center w-full gap-2 ">
                <div className="flex flex-row gap-4 w-full justify-between">
                  <div className="w-[70%]">
                    <DefaultFormInput
                      name="formaPagamento"
                      label="Forma de Pagamento"
                      readOnly={false}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                  <div className="w-[30%]">
                    <FormDatePickerInput
                      name="dataCompetencia"
                      label="Competência"
                      tipoData="mes"
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                </div>

                <div className="w-[70%]"></div>

                <div className="flex flex-row gap-4 w-full justify-between">
                  <DefaultFormInput
                    name="nome"
                    label="Titulo/Pedido"
                    readOnly={false}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4 w-full justify-between">
                  <div className=" flex flex-row gap-2">
                    <div className="w-[70%]">
                      {
                        viewModel.variasOrdensCompra ? (
                          <DefaultFormMultiAutocomplete
                            name="listaIdOrdemCompra"
                            required={false}
                            label="Ordem de Compra"
                            options={viewModel.ddlOrdemCompra ?? []}
                            getOptionLabel={(x) => x.title}
                            getOptionKey={(x) => x.id}
                            reactHookForm={viewModel.hookForm}
                          />
                        ) : (<DefaultFormAutocomplete
                          name="idOrdemCompra"
                          required={false}
                          label="Ordem de Compra"
                          options={viewModel.ddlOrdemCompra ?? []}
                          getOptionLabel={(x) => x.title}
                          getOptionKey={(x) => x.id}
                          reactHookForm={viewModel.hookForm}
                        />)
                      }
                    </div>
                    <div className="w-[30%]">
                      <DefaultCheckBox
                        name='variasOrdensCompra'
                        label='Varias Ordens de Compra'
                        value={viewModel.variasOrdensCompra}
                        onChangeValue={e => viewModel.handleMultiOrdemComprasChange(e)}
                      />
                    </div>
                  </div>
                  <DropDownCentroCusto
                    name="idCentroCusto"
                    label="Centro de Custo"
                    required={true}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <div className="grid grid-cols-3 gap-4 w-full justify-between">
                  <div className="w-full">
                    <DropDownSubconta
                      name="idSubconta"
                      label="Subconta"
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                  {viewModel.isFornecedor ? (
                    <div className="w-full">
                      <DropDownFornecedor
                        name="idFornecedor"
                        label="Fornecedor"
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  ) : (
                    <div className="w-full">
                      <DropDownFuncionario
                        name="idFuncionarioPago"
                        required={false}
                        readOnly={false}
                        label="Funcionário"
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  )}

                  <div className="flex items-center justify-between w-[20%]">
                    <FormSwitchInput
                      name="isFornecedor"
                      activeLabel="Fornecedor"
                      inactiveLabel="Funcionário"
                      readOnly={viewModel.saving}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 w-full justify-between">
                  <DefaultFormMoneyInput
                    name="valorPagar"
                    label="Valor a Pagar"
                    required
                    reactHookForm={viewModel.hookForm}
                  />

                  <FormDatePickerInput
                    name="dataPagar"
                    label="Data a Pagar"
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4 w-full justify-between">
                  <DropDownFuncionario
                    name="idFuncionario"
                    required={false}
                    readOnly={false}
                    label="Responsável"
                    reactHookForm={viewModel.hookForm}
                  />

                  <DropDownProdutoServico
                    name="idProdutoServico"
                    required={false}
                    readOnly={false}
                    label="Produto/Serviço"
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <div className="w-full">
                  <DefaultFormInput
                    name="nrNotaFiscal"
                    label="N° Nota Fiscal"
                    multiline
                    rows={2}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <DefaultFormInput
                  name="nrDocumentos"
                  label="N° Documento"
                  multiline
                  rows={2}
                  reactHookForm={viewModel.hookForm}
                />

                <DefaultFormInput
                  name="informacoesGerais"
                  label="Informações Gerais"
                  multiline
                  rows={4}
                  reactHookForm={viewModel.hookForm}
                />

                <DefaultFormInput
                  name="observacao"
                  label="Observações"
                  multiline
                  rows={4}
                  reactHookForm={viewModel.hookForm}
                />
              </div>
            </FormContainer>

            {viewModel.informacoesBancariasFornecedor && (
              <FormContainer
                title="Dados Bancários - Fornecedor"
                arrangement="fullRow"
                border={false}
              >
                <div className="flex flex-col items-center w-full gap-4">
                  <div className="grid grid-cols-2 gap-4 w-full">
                    <DefaultInput
                      name="nomeBanco"
                      label="Nome Banco"
                      readOnly={true}
                      value={viewModel.informacoesBancariasFornecedor.nomeBanco}
                    />

                    <DefaultRadioGroupInput
                      name="tipoConta"
                      label="Tipo Conta"
                      readOnly={true}
                      options={[
                        { id: 0, label: "Corrente" },
                        { id: 1, label: "Poupança" },
                      ]}
                      value={
                        viewModel.informacoesBancariasFornecedor.tipoConta ?? 0
                      }
                      onValueChange={() => { }}
                    />
                  </div>

                  <div className="grid grid-cols-3 gap-4 w-full items-center">
                    <DefaultInput
                      name="nrAgencia"
                      label="Agência"
                      readOnly={true}
                      value={viewModel.informacoesBancariasFornecedor.agencia}
                    />

                    <div className="flex flew-row gap-2 items-center">
                      <DefaultInput
                        name="nrConta"
                        label="Conta"
                        readOnly={true}
                        value={viewModel.informacoesBancariasFornecedor.nrConta}
                      />
                      <span className="text-gray-400 font-bold">-</span>
                      <div className="w-[40%]">
                        <DefaultInput
                          name="dvConta"
                          label="DV"
                          readOnly={true}
                          value={
                            viewModel.informacoesBancariasFornecedor.digito
                          }
                          className="w-[5rem]"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 w-full">
                    <DefaultInput
                      name="nrOperacao"
                      label="operacao"
                      readOnly={true}
                      value={viewModel.informacoesBancariasFornecedor.operacao}
                    />

                    <DefaultInput
                      name="Pix"
                      label="Pix"
                      readOnly={true}
                      value={viewModel.informacoesBancariasFornecedor.pix}
                    />
                  </div>
                </div>
              </FormContainer>
            )}

            {viewModel.informacoesBancariasFuncionario && (
              <FormContainer
                title="Dados Bancários - Funcionário"
                arrangement="fullRow"
                border={false}
              >
                <div className="flex flex-col items-center w-full gap-4">
                  {/* LINHA 1 - SELECIONAR BANCO */}
                  <div className="grid grid-cols-2 gap-4 w-full">
                    <DefaultInput
                      name="nomeFuncionario"
                      label="Nome do Funcionário"
                      readOnly={true}
                      value={
                        viewModel.informacoesBancariasFuncionario
                          .nomeFuncionario
                      }
                    />
                  </div>

                  {/* LINHA 3 - BANCO, AGÊNCIA, CONTA, OPERAÇÃO */}
                  <div className="grid grid-cols-3 gap-4 w-full items-center">
                    <DefaultInput
                      name="nomeBanco"
                      label="Nome Banco"
                      readOnly={true}
                      value={
                        viewModel.informacoesBancariasFuncionario.nomeBanco
                      }
                    />

                    <DefaultInput
                      name="nrAgencia"
                      label="Agência"
                      readOnly={true}
                      value={viewModel.informacoesBancariasFuncionario.agencia}
                    />

                    <div className="flex flew-row gap-2 items-center">
                      <DefaultInput
                        name="nrConta"
                        label="Conta"
                        readOnly={true}
                        value={
                          viewModel.informacoesBancariasFuncionario.nrConta
                        }
                      />
                      <span className="text-gray-400 font-bold">-</span>
                      <div className="w-[40%]">
                        <DefaultInput
                          name="dvConta"
                          label="DV"
                          readOnly={true}
                          value={
                            viewModel.informacoesBancariasFuncionario.digito
                          }
                          className="w-[5rem]"
                        />
                      </div>
                    </div>
                  </div>

                  {/* LINHA 4 - PIX */}
                  <div className="grid grid-cols-2 gap-4 w-full">
                    <DefaultInput
                      name="nrOperacao"
                      label="operacao"
                      readOnly={true}
                      value={viewModel.informacoesBancariasFuncionario.operacao}
                    />

                    <DefaultInput
                      name="Pix"
                      label="Pix"
                      readOnly={true}
                      value={viewModel.informacoesBancariasFuncionario.pix}
                    />
                  </div>
                </div>
              </FormContainer>
            )}

            {/* ANEXOS */}
            <FormContainer title="Anexo" arrangement="fullRow" border={false}>
              <>
                <div className="w-full pb-4 flex flex-row justify-between items-center gap-4">
                  <div className="w-[40%] justify-start ">
                    <Controller
                      name="arquivo1"
                      control={viewModel.hookForm.control}
                      render={({ field }) =>
                        viewModel.contaPagar &&
                          viewModel.contaPagar.nomeArquivo1 &&
                          viewModel.contaPagar.nomeArquivo1.length > 0 ? (
                          <div className="w-full flex flex-row justify-between items-center">
                            <span
                              className="cursor-pointer"
                              onMouseDown={() => viewModel.handleDownload(1, viewModel.contaPagar?.nomeArquivo1 ?? "")}
                            >
                              {viewModel.contaPagar.nomeArquivo1 &&
                                viewModel.contaPagar.nomeArquivo1.length > 40
                                ? `${viewModel.contaPagar.nomeArquivo1.substring(0, 40)}...`
                                : viewModel.contaPagar.nomeArquivo1}
                            </span>
                            <IconButton
                              onClick={() =>
                                viewModel.handleArquivoDeleteOpenState(
                                  "limparArquivo1",
                                  "nomeArquivo1",
                                  true,
                                )
                              }
                            >
                              <DynamicIcon
                                nameIcon="DeleteForeverRounded"
                                size={25}
                                className="text-red-500"
                              />
                            </IconButton>
                          </div>
                        ) : (
                          <PrimaryButton
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            disabled={viewModel.saving}
                            startIcon={
                              <DynamicIcon
                                nameIcon="Download"
                                size={25}
                                className="text-white"
                              />
                            }
                          >
                            {field.value
                              ? field.value.name
                              : "Escolher arquivo"}
                            <VisuallyHiddenInput
                              type="file"
                              onChange={(e) =>
                                viewModel.handleFileChange(
                                  "nomeArquivo1",
                                  "limparArquivo1",
                                  e,
                                  field.onChange,
                                )
                              }
                              multiple={false}
                            />
                          </PrimaryButton>
                        )
                      }
                    />
                  </div>

                  <div className="mt-2 gap-3 text-sm text-gray-600">
                    Tamanho total dos arquivos:{" "}
                    <span className="font-medium text-gray-800">
                      {(
                        ((viewModel.contaPagar?.tamanhoArquivo1 || 0) +
                          (viewModel.contaPagar?.tamanhoArquivo2 || 0) +
                          (viewModel.contaPagar?.tamanhoArquivo3 || 0)) /
                        (1024 * 1024)
                      ).toFixed(2)}{" "}
                      MB
                    </span>
                  </div>
                </div>

                <div className="w-full pb-4">
                  <div className="w-[40%] justify-start">
                    <Controller
                      name="arquivo2"
                      control={viewModel.hookForm.control}
                      render={({ field }) =>
                        viewModel.contaPagar &&
                          viewModel.contaPagar.nomeArquivo2 &&
                          viewModel.contaPagar.nomeArquivo2.length > 0 ? (
                          <div className="w-full flex flex-row justify-between items-center">
                            <span
                              className="cursor-pointer"
                              onMouseDown={() => viewModel.handleDownload(2, viewModel.contaPagar?.nomeArquivo2 || '')}
                            >
                              {viewModel.contaPagar.nomeArquivo2 &&
                                viewModel.contaPagar.nomeArquivo2.length > 40
                                ? `${viewModel.contaPagar.nomeArquivo2.substring(0, 40)}...`
                                : viewModel.contaPagar.nomeArquivo2}
                            </span>
                            <IconButton
                              onClick={() =>
                                viewModel.handleArquivoDeleteOpenState(
                                  "limparArquivo2",
                                  "nomeArquivo2",
                                  true,
                                )
                              }
                            >
                              <DynamicIcon
                                nameIcon="DeleteForeverRounded"
                                size={25}
                                className="text-red-500"
                              />
                            </IconButton>
                          </div>
                        ) : (
                          <PrimaryButton
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            disabled={viewModel.saving}
                            startIcon={
                              <DynamicIcon
                                nameIcon="Download"
                                size={25}
                                className="text-white"
                              />
                            }
                          >
                            {field.value
                              ? field.value.name
                              : "Escolher arquivo"}
                            <VisuallyHiddenInput
                              type="file"
                              onChange={(e) =>
                                viewModel.handleFileChange(
                                  "nomeArquivo2",
                                  "limparArquivo2",
                                  e,
                                  field.onChange,
                                )
                              }
                              multiple={false}
                            />
                          </PrimaryButton>
                        )
                      }
                    />
                  </div>
                </div>

                <div className="w-full pb-4">
                  <div className="w-[40%] justify-start">
                    <Controller
                      name="arquivo3"
                      control={viewModel.hookForm.control}
                      render={({ field }) =>
                        viewModel.contaPagar &&
                          viewModel.contaPagar.nomeArquivo3 &&
                          viewModel.contaPagar.nomeArquivo3.length > 0 ? (
                          <div className="w-full flex flex-row justify-between items-center">
                            <span
                              className="cursor-pointer"
                              onMouseDown={() => viewModel.handleDownload(3, viewModel.contaPagar?.nomeArquivo3 ?? "")}
                            >
                              {viewModel.contaPagar.nomeArquivo3 &&
                                viewModel.contaPagar.nomeArquivo3.length > 40
                                ? `${viewModel.contaPagar.nomeArquivo3.substring(0, 40)}...`
                                : viewModel.contaPagar.nomeArquivo3}
                            </span>
                            <IconButton
                              onClick={() =>
                                viewModel.handleArquivoDeleteOpenState(
                                  "limparArquivo3",
                                  "nomeArquivo3",
                                  true,
                                )
                              }
                            >
                              <DynamicIcon
                                nameIcon="DeleteForeverRounded"
                                size={25}
                                className="text-red-500"
                              />
                            </IconButton>
                          </div>
                        ) : (
                          <PrimaryButton
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            disabled={viewModel.saving}
                            startIcon={
                              <DynamicIcon
                                nameIcon="Download"
                                size={25}
                                className="text-white"
                              />
                            }
                          >
                            {field.value
                              ? field.value.name
                              : "Escolher arquivo"}
                            <VisuallyHiddenInput
                              type="file"
                              onChange={(e) =>
                                viewModel.handleFileChange(
                                  "nomeArquivo3",
                                  "limparArquivo3",
                                  e,
                                  field.onChange,
                                )
                              }
                              multiple={false}
                            />
                          </PrimaryButton>
                        )
                      }
                    />
                  </div>
                </div>

              </>
            </FormContainer>
          </div>
        </div>

        <BottomBar>
          <div className="w-full h-full flex justify-between items-center p-4 gap-6">
            <div>
              {viewModel.contaPagar && (
                <>
                  <div>
                    <PrimaryButton
                      buttonColor="yellow"
                      onClick={() =>
                        viewModel.handleOpenChangeHistory(
                          viewModel.contaPagar?.idContasPagar ?? null,
                          null,
                        )
                      }
                    >
                      <span className="text-xs">Historico de alterações</span>
                    </PrimaryButton>
                  </div>
                </>
              )}
            </div>

            <div className="w-full h-full flex justify-end items-center p-4 gap-6">
              {viewModel.statusBloqueio && viewModel.contaPagar && (
                <div className="">
                  <PrimaryButton
                    onClick={() => viewModel.handleCancelarPagamento()}
                    buttonColor="red"
                  >
                    Cancelar Pagamento
                  </PrimaryButton>
                </div>
              )}

              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={() => viewModel.handlePageBack()}
                >
                  Cancelar
                </h1>
              </div>

              <div className="w-40">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    startIcon={
                      <DynamicIcon
                        nameIcon="CheckRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/* DELETE CONFIRMAÇÃO */}
      <DeleteDialog
        open={viewModel.openDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleContaPagarDeleteOpenState(null, false)}
        title="Você realmente deseja excluir esta Conta a Pagar?"
        onDelete={viewModel.handleConfirmarDeletarContaPagar}
      />

      {/* ARQUIVOS */}

      <DeleteDialog
        open={viewModel.openDeleteArquivoModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleArquivoDeleteOpenState(null, null, false)
        }
        title={`Você realmente deseja excluir este arquivo?`}
        onDelete={viewModel.handleConfirmarDeletarArquivo}
      />

      <CopiaContasPagarModal
        open={viewModel.openCopiaModal}
        saving={viewModel.saving}
        selectedIdContasPagar={viewModel.contaPagarSelectedId ?? 0}
        titulo={viewModel.tituloCopia ?? ""}
        onSubmit={viewModel.handleSubmitCopiaContaPagar}
        onClose={() => viewModel.handleContaPagarCopiaOpenState(false)}
      />

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />

      <ReportViewerModal reportViewerState={viewModel.reportViewerState} />
    </>
  );
};
